import { render, staticRenderFns } from "./StatisticIndex.vue?vue&type=template&id=38b1337a"
import script from "./StatisticIndex.vue?vue&type=script&lang=js"
export * from "./StatisticIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b1337a')) {
      api.createRecord('38b1337a', component.options)
    } else {
      api.reload('38b1337a', component.options)
    }
    module.hot.accept("./StatisticIndex.vue?vue&type=template&id=38b1337a", function () {
      api.rerender('38b1337a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/teacher/StatisticIndex.vue"
export default component.exports